// extracted by css-extract-rspack-plugin
export default {"suggestion":"_72783089","suggestionTitle":"_62dd8cc9"};